import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {ExportarExcel} from '../../utileria/exportar-tabla-excel';
import {Constants} from '../../constants/constants';
import {EventosTablaInterface} from '../../interfaces/eventos-tabla.interface';
import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-tabla-edit',
  templateUrl: './tabla-edit.component.html',
  styleUrls: ['./tabla-edit.component.scss']
})
export class TablaEditComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('idExportar') table: ElementRef;
  @Input() parametrosTablaEdit: any;
  @Output() emitter: EventEmitter<EventosTablaInterface> = new EventEmitter<EventosTablaInterface>();

  dataNames: string [] = [];
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>([]);
  formatColumn: string [] = [];
  editableColumn: string [] = [];
  editingRow: number | null = null;
  addRow = false;
  isLoading = null;


  constructor(private excel: ExportarExcel,
              public constants: Constants,
              public toastr: ToastrService,
              private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.dataNames = this.parametrosTablaEdit.dataNames;
    this.dataNames.push('Acciones');
    this.displayedColumns = this.parametrosTablaEdit.displayedColumns;
    this.displayedColumns.push(this.constants.ACCIONES);
    this.formatColumn = this.parametrosTablaEdit.formatColumn;
    this.editableColumn = this.parametrosTablaEdit.editableColumn;

  }

  ngAfterViewInit() {
    this.getDataSource();
  }

  getDataSource() {
    setTimeout(() => {
      this.isLoading = true;
      this.parametrosTablaEdit.service.getDataList().subscribe(res => {
        this.dataSource = new MatTableDataSource<any>(res);
        this.dataSource.paginator = this.paginator;
        this.isLoading = false;
      }, () => this.isLoading = false);
    }, 500);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  startEdit(index: number) {
    this.editingRow = index;
  }

  saveEdit(tuple: any) {
    this.spinner.show();
    this.parametrosTablaEdit.service.post(tuple).subscribe((res) => {
      if (res != undefined && res != false) {
        this.toastr.success('Se edito correctamente la información.', 'Guardado Exitoso');
        this.editingRow = null;
        this.getDataSource();
        this.spinner.hide();
      }
    }, () => this.spinner.hide());
  }

  cancelEdit() {
    this.editingRow = null;
    this.addRow = false;
    this.getDataSource();
  }

  addNewRow() {
    Object.keys(this.parametrosTablaEdit.newItem).forEach(clave => {
      this.parametrosTablaEdit.newItem[clave] = '';
    });
    this.parametrosTablaEdit.newItem.isNew = true;
    const newItem: any = this.parametrosTablaEdit.newItem;
    this.dataSource.data = [newItem, ...this.dataSource.data];
    this.paginator.firstPage();
    this.addRow = true;
  }

  saveNew(tuple: any) {
    this.spinner.show();
    this.parametrosTablaEdit.service.post(tuple).subscribe((res) => {
      if (res != undefined && res != false) {
        this.toastr.success('Se almaceno correctamente la información.', 'Guardado Exitoso');
        tuple.isNew = false;
        this.addRow = false;
        this.getDataSource();
        this.spinner.hide();
      }
    }, () => {
      tuple.isNew = true;
      this.spinner.hide();
    });
  }

  cancelNew(tuple: any) {
    this.dataSource.data = this.dataSource.data.filter(u => u !== tuple);
    this.addRow = false;
  }

  deleteRow(tuple: any) {
    this.parametrosTablaEdit.service.delete().subscribe(() => {
      this.dataSource.data = this.dataSource.data.filter(u => u !== tuple);
    });
  }

  exportTable(): void {
    this.excel.exportarExcel(this.table);
  }

  exit(): void {
    this.emitter.emit({
      accion: this.constants.REGRESAR
    });
  }

}
